import { useContext, useMemo } from "react";
import AddPageSubMenu from "src/components/layouts/AddPageSubMenu";
import PatientIdentityContext from "src/contexts/data/PatientIdentityContext";
import TrialIdentityContext from "src/contexts/data/TrialIdentityContext";
import TrialInstitutionIdentityContext from "src/contexts/data/TrialInstitutionIdentityContext";
import { createPatientSubMenu } from "src/routing/navigation";

const PatientSubMenu: React.FC = () => {
    const { data: trialIdentity } = useContext(TrialIdentityContext);
    const { data: trialInstitutionIdentity } = useContext(TrialInstitutionIdentityContext);
    const { data: patientIdentity } = useContext(PatientIdentityContext);

    const subMenu = useMemo(() => {
        if (!trialIdentity || !patientIdentity) {
            return null;
        }

        return createPatientSubMenu(trialIdentity, trialInstitutionIdentity, patientIdentity);
    }, [trialIdentity, trialInstitutionIdentity, patientIdentity]);

    if (!subMenu) {
        return null;
    }

    return <AddPageSubMenu subMenu={subMenu} />;
};

export default PatientSubMenu;
